import CustomHttpClient from '../customHttpClient';

import { getError, getUserInfo } from '../../utils';

import { Intermediary } from '../../interfaces';
import { GetTotalProductionsListServiceResponse } from '../../interfaces/services/total-production';

const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });

const TotalProductionService = {
  async getTotalProduction(
    filters: Intermediary | undefined
  ): Promise<GetTotalProductionsListServiceResponse> {
    const url = 'totalProduccion';

    try {
      const params = filters
        ? {
            sucursal: 'CA',
            empresa: 'A',
            nivt: filters.nivelInter,
            nivc: filters.codigoInter,
            niv1: filters.codigoInter,
            nit1: filters.nivelInter,
          }
        : { ...getUserInfo() };

      const response = await customHttpClient.get(url, { params });

      let TotalProductionResponse = response.data;

      return TotalProductionResponse;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
};

export default TotalProductionService;
